<div class="main-bg page-height w-full h-full overflow-auto">
  @if(isLoading()){
  <app-loading-spinner text="Blog Posts"></app-loading-spinner>
  } @if(error()){
  <div class="w-full h-full flex flex-row items-center justify-center">
    <div class="text-red-400 text-lg flex flex-col items-center gap-3">
      <mat-icon matSuffix fontIcon="error"></mat-icon>
      <p>Error Getting Daily</p>
    </div>
  </div>
  } @if (postLink() == null && !isLoading() ){
  <p class="text-4xl font-medium p-3 m-5">Johnston's Daily</p>
  <div class="flex flex-col items-center justify-between">
    @for(post of posts(); track post.id; let i = $index){
    <mat-card
      matRipple
      class="w-11/12 p-4 m-2 rounded flex flex-row items-start justify-between hover:cursor-pointer text-orange-400"
      (click)="selectPost(post.link)"
    >
      <mat-card-header>
        <mat-card-title>
          <span
            matBadge="1"
            [matBadgeHidden]="readDaily() || i !== 0"
            matBadgeColor="accent"
            matBadgeSize="medium"
            [matBadgeOverlap]="false"
            matBadgePosition="above"
          >
            {{ post.title.rendered | htmlDecode }}
          </span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="my-1 mx-2">
        <p>{{ post.date | date : "longDate" }}</p>
        <!-- <mat-icon matSuffix fontIcon="chevron_right"></mat-icon> -->
      </mat-card-content>
      <mat-card-footer></mat-card-footer>
    </mat-card>
    }
  </div>
  } @else if(postLink()) {
  <div
    class="flex flex-row gap-3 justify-between items-center p-4 my-6 mx-2 tablet-min:mx-10"
  >
    <div
      class="flex flex-row gap-3 hover:cursor-pointer"
      (click)="postLink.set(null)"
    >
      <mat-icon matSuffix fontIcon="arrow_back_ios"> </mat-icon>
      <span>Back</span>
    </div>
    <div>
      <a
        target="_blank"
        rel="noopener noreferrer"
        class="underline"
        [href]="postLink()"
        >Open in New Tab</a
      >
    </div>
  </div>

  <div class="iframe-container flex flex-col justify-center items-center">
    <iframe
      [src]="postLink() | safe"
      #blogFrame
      [class.loading]="isLoading()"
      (load)="onIframeLoad()"
      title="Johnston's Daily Blog"
      frameborder="0"
      allowfullscreen
      allow="autoplay; encrypted-media; picture-in-picture"
    >
    </iframe>
  </div>
  }
</div>
